var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"left"},[_c('el-image',{staticClass:"compImg",attrs:{"src":_vm.baseImgUrl + _vm.compImg}})],1),_c('div',{staticClass:"right"},[_c('div',{staticClass:"up"},[_vm._v(_vm._s(_vm.compIntro))]),_c('div',{staticClass:"down"},[_vm._v(_vm._s(_vm.compIContact))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }